import { HikvisionCameraDirectionEnum } from '@zaoblako/shared/modules/cctv/enums/hikvision-camera-direction.enum';
import { HikvisionCameraDirectionEnumI18n } from '@zaoblako/shared/modules/cctv/i18n/hikvision-camera-direction-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { ConverterFindInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-find.dto';

import * as yup from 'yup';

/** "Hikvision" CCTV camera credentials create and update APIs request body - DTO signature */
export interface HikvisionCameraFormInterface {
  /** Camera display name */
  name: string;
  /** Camera direction */
  direction: HikvisionCameraDirectionEnum;
  /** If `true`, then secured connection will be used */
  secured?: boolean;
  /** Camera connection host (IP-address or domain name) */
  host: string;
  /** Camera connection port number */
  port: number;
  /** Camera connection login */
  login: string;
  /** Camera connection login */
  password: string;
  /** If `true` then FRM will open barrier by sending command to "Iron Logic" device defined at {@link HikvisionCameraFormInterface.converter} field */
  openByConverter?: boolean;
  /** Converter connected to this camera */
  converter?: ConverterFindInterface;
}

/** "Hikvision" CCTV camera credentials create and update APIs request body - DTO schema */
export const HikvisionCameraFormDto = SerdeDtoClass.create<HikvisionCameraFormInterface>(CctvDtoKeysEnum.HIKVISION_CAMERA_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  direction: {
    label: 'Направление',
    serializer: commonEnumValidator(HikvisionCameraDirectionEnum, HikvisionCameraDirectionEnumI18n),
  },
  secured: {
    optional: true,
    label: 'Использовать защищенное соединение',
    serializer: yup.boolean(),
  },
  host: {
    label: 'Хост (IP-адрес или доменное имя)',
    serializer: nonEmptyStringSchema,
  },
  port: {
    label: 'Порт подключения',
    serializer: idLikeSchema,
  },
  login: {
    serializer: nonEmptyStringSchema,
    label: 'Логин',
  },
  password: {
    serializer: nonEmptyStringSchema,
    label: 'Пароль',
  },
  openByConverter: {
    optional: true,
    label: 'Открывать через конвертер',
    serializer: yup.boolean(),
  },
  converter: {
    optional: true,
    label: 'Оборудование',
    serializer: entityLikeSchema,
  },
});
